import React from "react";

const SortDownIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 11 9"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.43103 9L10.1344 0.853448H0.727621L5.43103 9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SortDownIcon;
